module.exports = __webpack_public_path__ + "static/img/a_42.be9cdcea.png";